import { tooFlat } from './model';
import { computePit, SHORE_DEPTH, SOIL_ANGLE } from './excavation';

const dm = (v) => String(+(+v).toFixed(2)).replace('.', ',');
// Tiefbau check list: lines below minimum cover + pits deeper than 1.25 m without shoring; ticks stored in project.civilOk
export function civilChecks(project, t) {
  const ok = project.civilOk || {};
  const pipes = (project.pipes || []).filter((p) => tooFlat(project, p)).map((p) => ({
    id: `pipe:${p.id}`, kind: 'pipe', name: p.name, text: t.ckFlat.replace('{d}', dm(String(p.depth).replace(',', '.'))).replace('{m}', dm(tooFlat(project, p))),
  }));
  const pits = (project.pits || []).filter((p) => p.soil !== 'shore' && computePit(p).depth > SHORE_DEPTH).map((p) => ({
    id: `pit:${p.id}`, kind: 'pit', name: p.name, text: (SOIL_ANGLE[p.soil] ? t.ckSlope.replace('{a}', SOIL_ANGLE[p.soil]) : t.ckOpen).replace('{d}', dm(computePit(p).depth)),
  }));
  return [...pipes, ...pits].map((x) => ({ ...x, done: !!ok[x.id] }));
}
